import { schema } from 'normalizr';

import { processUserHideField } from '../strategies/userHideField';

export const userHideFieldSchema = new schema.Entity('userHideFields', {}, { processStrategy: processUserHideField });
